// @flow
export const INIT = "init"
export const SUCCESS = "success"
export const LOADING = "loading"
export const ERROR = "error"

export type PhaseType = "init" | "success" | "loading" | "error"
